import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './Label.css'

const propTypes = {
  /** Visual styles */
  kind: PropTypes.oneOf(['dark', 'light']),
  /** Custom CSS Classes */
  className: PropTypes.string,
  children: PropTypes.any,
}

const defaultProps = {
  kind: 'dark'
}

/**
 * Used inside the `FieldSet` and a corresponding Input
 */
const Label = ({children, className, ...props}) => {
  const classes = classNames(
    'component-label',
    styles.label,
    styles[props.kind],
    className
    // propBasedClasses
  )
  return (
    <div {...props} className={classes}>
      {children}
    </div>
  )
}

Label.propTypes = propTypes
Label.defaultProps = defaultProps
export default Label



// WEBPACK FOOTER //
// ../src/components/Label/Label.js